import { type ComponentProps, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface TwapUnitInputProps extends Omit<ComponentProps<'input'>, 'type'> {
  /** Muted label pinned inside the right edge (`%`, `sec`, the size unit, ...). */
  unit: ReactNode
}

/**
 * Compact right-aligned numeric field with an in-field unit suffix, shared by the TWAP / advanced
 * TWAP param inputs. Pass `className` to widen the right padding for longer units or change height.
 */
export function TwapUnitInput({ unit, className, ...props }: TwapUnitInputProps) {
  return (
    <div className="relative">
      <input
        type="text"
        className={cn(
          'border-foreground/10 bg-foreground/5 text-foreground placeholder:text-foreground/30 focus:border-foreground/40 h-9 w-full border pr-14 pl-3 text-right text-sm transition-colors outline-none',
          className
        )}
        {...props}
      />
      <span className="text-foreground/40 pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-sm">
        {unit}
      </span>
    </div>
  )
}
